import _ from 'lodash';
import {ModalType} from '@treez-ui/core/feedback/modals';
import {ReactNode} from 'react';
import {ButtonClass} from '@treez-ui/core/buttons/Button';
import {Action} from 'redux';
import {AppThunk} from '../store';

export enum FeedbackAction {
    CLOSE_FEEDBACK_MODAL = 'CLOSE_FEEDBACK_MODAL',
    OPEN_FEEDBACK_MODAL = 'OPEN_FEEDBACK_MODAL',
}

export interface OpenFeedbackOptions {
    bodyElement?: ReactNode;
    bodyText?: string;
    buttonClass?: ButtonClass;
    buttonIcon?: ReactNode;
    buttonText?: string;
    cancelOption?: boolean;
    onCancel?: () => void;
    type?: ModalType;
}

export interface OpenFeedbackValue {
    action: () => void;
    title: string;
    options?: OpenFeedbackOptions;
}

const {CLOSE_FEEDBACK_MODAL, OPEN_FEEDBACK_MODAL} = FeedbackAction;

export const closeFeedbackModal = () => ({
    type: CLOSE_FEEDBACK_MODAL,
});

export const openFeedbackModal = (
    action: () => void | Promise<void> | AppThunk | Action<FeedbackAction>,
    title: string,
    options?: OpenFeedbackOptions
) => {
    const optionsPassed = _.omitBy(options, _.isUndefined);

    return {
        type: OPEN_FEEDBACK_MODAL,
        value: _.omitBy(
            {
                action,
                title,
                ...optionsPassed,
            },
            _.isUndefined
        ),
    };
};

// Action Creators
